module.exports = {
    activaityCityList: [],
}


// WEBPACK FOOTER //
// ./src/store/aboutCity/state.js